import Vue from "vue";
import VueRouter from "vue-router";
import axios from "../plugins/axios";
import { i18n } from "../plugins/vue-i18n";

import Main from "../pages/client/Main.vue";

// import { BoardRoutes } from "./board.router";
// import { QuestionRoutes } from "./question.router";

Vue.use(VueRouter);

const routes = [
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // 사용자 페이지 라우트
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    {
        // Main 페이지
        path: "/",
        component: Main,
    },

    // 편안하지흉부외과 (introduction)
    {
        // 판안하지 소개
        path: "/introduction",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/introduction/IntroductionPage.vue"),
        props: true,
    },
    {
        // 의료진 소개
        path: "/introduction/team",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/introduction/TeamPage.vue"),
        props: true,
    },
    {
        // 병원 둘러보기 
        path: "/introduction/panorama",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/introduction/PanoramaPage.vue"),
        props: true,
    },
    // {
    //     // (구)고객리뷰
    //     path: "/review",
    //     component: () => import(/* webpackChunkName: "board" */ "../pages/client/review/ReviewPage.vue"),
    //     props: true,
    // },
    {
        // 고객리뷰 리스트
        path: "/review",
        component: () => import(/* webpackChunkName: "board" */ "../pages/client/sub/introduction/reviewBoard/ReviewListPage.vue"),
        props: true,
    },
    {
        // 고객리뷰 작성
        path: "/review/write",
        component: () => import(/* webpackChunkName: "board" */ "../pages/client/sub/introduction/reviewBoard/ReviewWritePage.vue"),
        props: true,
    },
    {
        // 고객리뷰 상세
        path: "/review/:_id",
        component: () => import(/* webpackChunkName: "board" */ "../pages/client/sub/introduction/reviewBoard/ReviewViewPage.vue"),
        props: true,
    },
    {
        // 진료시간 & 오시는 길 
        path: "/introduction/information",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/introduction/InformationPage.vue"),
        props: true,
    },
    // 하지정맥류 (varicose)
    {
        // 하지정맥류란?
        path: "/varicose",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/varicose/VaricoseVeinPage.vue"),
        props: true,
    },
    {
        // 하지정맥류 자가진단
        path: "/varicose/self-diagnosis",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/varicose/SelfDiagnosisPage.vue"),
        props: true,
    },
    {
        // 하지정맥류 치료 기준
        path: "/varicose/standards",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/varicose/StandardsPage.vue"),
        props: true,
    },
    {
        // 하지정맥류 치료 원칙
        path: "/varicose/principles",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/varicose/PrinciplesPage.vue"),
        props: true,
    },
    // 하지정맥류 비수술 (non-surgical)
    {
        // 압박스타킹
        path: "/non-surgical/stockings",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/non-surgical/StockingsPage.vue"),
        props: true,
    },
    {
        // 경구약(정맥순환개선제)
        path: "/non-surgical/drugs",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/non-surgical/DrugsPage.vue"),
        props: true,
    },
    {
        // 혈관경화요법(주사치료)
        path: "/non-surgical/sclerotherapy",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/non-surgical/SclerotherapyPage.vue"),
        props: true,
    },
    // 하지정맥류 수술 (surgery)
    {
        // 클라리베인
        path: "/surgery/clarivein",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/surgery/ClariveinPage.vue"),
        props: true,
    },
    {
        // 플레보그립
        path: "/surgery/flebogrif",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/surgery/FlebogrifPage.vue"),
        props: true,
    },
    {
        // 베나실
        path: "/surgery/venaseal",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/surgery/VenaSealPage.vue"),
        props: true,
    },
    {
        // 고주파 수술
        path: "/surgery/rfa",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/surgery/RfaPage.vue"),
        props: true,
    },
    {
        // 레이저 수술
        path: "/surgery/laser",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/surgery/LaserPage.vue"),
        props: true,
    },
    {
        // 발거술
        path: "/surgery/stripping",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/surgery/StrippingPage.vue"),
        props: true,
    },
    // 치료비용 안내
    {
        // 편안하지 수술비 안내
        path: "/cost",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/sub/cost/CostGuidePage.vue"),
        props: true,
    },

    {
        // 가이드
        path: "/guide",
        component: () => import(/* webpackChunkName: "guide" */ "../pages/client/guide/guide-app.vue"),
        props: true,
    },
    {
        // 예시페이지
        path: "/ex",
        component: () => import(/* webpackChunkName: "guide" */ "../pages/client/sub/example-page.vue"),
        props: true,
    },


    // 게시판
    {
        // FAQ
        path: "/center/faqs",
        component: () => import(/* webpackChunkName: "center" */ "../pages/client/center/faq.vue"),
        props: true,
    },
    {
        // 공지사항
        path: "/center/notice",
        component: () => import(/* webpackChunkName: "center" */ "../pages/client/center/notice.vue"),
        props: true,
    },
    {
        // 공지사항
        path: "/center/notice/:_notification",
        component: () => import(/* webpackChunkName: "center" */ "../pages/client/center/notice.vue"),
        props: true,
    },

    // 폼메일
    {
        // 기본폼
        path: "/default-form",
        component: () => import(/* webpackChunkName: "form" */ "../pages/client/form/default-form.vue"),
        props: true,
    },

    // 약관
    {
        // 개인정보처리방침
        path: "/privacy-policy",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/center/privacy-policy.vue"),
        props: true,
    },
    {
        // 이용약관
        path: "/terms-use",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/center/terms-use.vue"),
        props: true,
    },

    // kcp
    // {
    //     path: "/common/kcp/cert/request",
    //     component: () => import("../pages/common/kcp/KCPCertRequest.vue"),
    //     props: true,
    // },
    // {
    //     path: "/common/kcp/cert/response",
    //     component: () => import("../pages/common/kcp/KCPCertResponse.vue"),
    //     props: true,
    // },

    // 로그인/회원가입
    // {
    //     // 로그인
    //     path: "/login",
    //     component: () => import(/* webpackChunkName: "login" */ "../pages/client/login/main.vue"),
    //     props: true,
    // },
    // {
    //     // 비밀번호 찾기
    //     path: "/login/find-password",
    //     component: () => import(/* webpackChunkName: "login" */ "../pages/client/login/find-password.vue"),
    //     props: true,
    // },
    // {
    //     // 아이디 찾기
    //     path: "/login/find-id",
    //     component: () => import(/* webpackChunkName: "login" */ "../pages/client/login/find-id.vue"),
    //     props: true,
    // },
    // {
    //     // 회원가입
    //     path: "/join",
    //     component: () => import(/* webpackChunkName: "join" */ "../pages/client/join/main.vue"),
    //     props: true,
    // },
    // {
    //     // 회원가입 폼
    //     path: "/join/type",
    //     component: () => import(/* webpackChunkName: "join" */ "../pages/client/join/type.vue"),
    //     props: true,
    // },
    // {
    //     // 회원가입 폼
    //     path: "/join/form",
    //     component: () => import(/* webpackChunkName: "join" */ "../pages/client/join/form.vue"),
    //     props: true,
    // },
    // {
    //     // 회원가입 완료
    //     path: "/join/complete",
    //     component: () => import(/* webpackChunkName: "join" */ "../pages/client/join/complete.vue"),
    //     props: true,
    // },

    // 마이페이지
    // {
    //     // 1:1 문의
    //     path: "/mypage/question",
    //     component: () => import(/* webpackChunkName: "question" */ "../pages/client/mypage/question.vue"),
    //     children: [...QuestionRoutes],
    //     props: true,
    // },
    // {
    //     // 회원 정보 상세
    //     path: "/mypage/myinfo",
    //     component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/mypage/myinfo.vue"),
    //     props: true,
    // },
    // {
    //     // 회원 정보 변경
    //     path: "/mypage/myinfo/:tab",
    //     component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/mypage/myinfo.vue"),
    //     props: true,
    // },
    // {
    //     // 회원 탈퇴
    //     path: "/mypage/leave",
    //     component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/mypage/leave.vue"),
    //     props: true,
    // },
    // {
    //     // 회원 탈퇴
    //     path: "/mypage/leave/:tab",
    //     component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/mypage/leave.vue"),
    //     props: true,
    // },

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // 관리자 페이지 라우트
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    {
        // 관리자 메인
        path: "/console",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/Main.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 대시보드
        path: "/console/dashboard",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/Dashboard.vue"),
        props: true,
    },
    {
        // 관리자 - 대시보드
        path: "/console/user/admins",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/user/admins/index.vue"),
        props: true,
    },
    {
        // 관리자 - 대시보드
        path: "/console/user/admins/create",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/user/admins/view.vue"),
        props: true,
    },
    {
        // 관리자 - 대시보드
        path: "/console/user/admins/:_id",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/user/admins/view.vue"),
        props: true,
    },
    {
        // 관리자 - 대시보드
        path: "/console/easyleg/main",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/easyleg/main.vue"),
        props: true,
    },
    {
        // 관리자 - 대시보드
        path: "/console/easyleg/reviews",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/easyleg/reviews/index.vue"),
        props: true,
    },
    {
        // 관리자 - 대시보드
        path: "/console/easyleg/reviews/create",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/easyleg/reviews/view.vue"),
        props: true,
    },
    {
        // 관리자 - 대시보드
        path: "/console/easyleg/reviews/:_id",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/easyleg/reviews/view.vue"),
        props: true,
    },
    {
        // 관리자 - 대시보드
        path: "/console/easyleg/reviews2",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/easyleg/reviews2/index.vue"),
        props: true,
    },    
    {
        // 관리자 - 대시보드
        path: "/console/easyleg/reviews2/create",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/easyleg/reviews2/view.vue"),
        props: true,
    },
    {
        // 관리자 - 대시보드
        path: "/console/easyleg/reviews2/:_id",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/easyleg/reviews2/view.vue"),
        props: true,
    },
    {
        // 관리자 - 게시판관리
        path: "/console/boards",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/board/BoardList.vue"),
    },
    {
        // 관리자 - 게시판관리
        path: "/console/boards/create",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/board/BoardView.vue"),
    },
    {
        // 관리자 - 게시판관리
        path: "/console/boards/:_board",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/board/BoardView.vue"),
    },
    {
        // 관리자 - 폼메일관리
        path: "/console/forms",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/form/FormList.vue"),
    },
    {
        // 관리자 - 폼메일관리
        path: "/console/forms/:_form",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/form/FormView.vue"),
    },
    {
        // 관리자 - 회원등급
        path: "/console/users/levels",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/user/LevelList.vue"),
        props: true,
    },
    {
        // 관리자 - 회원등급
        path: "/console/users/withdrawals",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/user/WithdrawalList.vue"),
        props: true,
    },
    {
        // 관리자 - 사용자
        path: "/console/users",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/user/UserList.vue"),
        props: true,
    },
    {
        // 관리자 - 사용자
        path: "/console/users/create",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/user/UserView.vue"),
        props: true,
    },
    {
        // 관리자 - 사용자
        path: "/console/users/:_user",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/user/UserView.vue"),
        props: true,
    },
    {
        // 관리자 - 공지사항
        path: "/console/center/notifications",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/center/Notification.vue"),
        props: true,
    },
    {
        // 관리자 - FAQ
        path: "/console/center/faqs",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/center/Faq.vue"),
        props: true,
    },
    {
        // 관리자 - 1:1문의
        path: "/console/center/questions",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/center/Question.vue"),
        props: true,
    },
    {
        // 관리자 - 서비스 이용약관
        path: "/console/terms",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/terms/TermsList.vue"),
        props: true,
    },
    {
        // 관리자 - 배너
        path: "/console/banners",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/banner/BannerList.vue"),
        props: true,
    },
    {
        // 관리자 - 배너
        path: "/console/banners/create",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/banner/BannerView.vue"),
        props: true,
    },
    {
        // 관리자 - 배너
        path: "/console/banners/:_banner",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/banner/BannerView.vue"),
        props: true,
    },
    {
        // 관리자 - 팝업
        path: "/console/popups",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/popup/PopupList.vue"),
        props: true,
    },
    {
        // 관리자 - 설정
        path: "/console/setting",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/setting/SettingView.vue"),
        props: true,
    },
    {
        // 관리자 - 비밀번호
        path: "/console/password",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/setting/PasswordView.vue"),
        props: true,
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,

    scrollBehavior: (to, from, savedPosition) => {
        let scrollTo = undefined;

        if (to.hash) {
            scrollTo = to.hash;
        } else if (savedPosition) {
            scrollTo = savedPosition.y;
        }

        if (scrollTo != undefined)
            return {
                selector: scrollTo,
                behavior: "smooth",
            };
    },
});

router.beforeEach((to, from, next) => {
    try {
        const accessToken = sessionStorage.getItem("accessToken");
        axios.defaults.headers.common["Authorization"] = !!accessToken ? `Bearer ${accessToken}` : "";
        axios.defaults.headers.common["Accept-Language"] = i18n.locale;

        const route = routes.find((route) => route.path == to.path);
        if (!route?.scope) next();
        else {
            if (!accessToken) {
                if (0 <= to.path.indexOf("console")) {
                    next();
                    return;
                } else throw new Error("로그인 후 이용가능합니다");
            }

            const payload = JSON.parse(atob(accessToken.split(".")[1]));
            const scope = payload?.scope || [];

            if (!scope.find((scope) => route.scope.includes(scope))) {
                throw new Error("접근권한이 없습니다");
            }

            next();
        }
    } catch (error) {
        alert(error.message);
        window.location.href = routes.find((route) => route.path == from.path)?.path ?? routes.find((route) => route.path == "/")?.path ?? "about:blank";
    }
});

export default router;
